export default __webpack_public_path__ + "static/media/IMG_0361.09595a64.jpeg";